import http from './http'

/**
 * 香港六合彩历史开奖（走后端代理请求第三方接口）
 * 参数: pageNum, lotteryType=1, year, sort=1
 */
export function fetchHkHistory({ pageNum = 1, year, sort = 1 } = {}) {
  const y = year != null ? year : new Date().getFullYear()
  return http.get('/api/hk-lot-draws/history', {
    params: { pageNum, lotteryType: 1, year: y, sort }
  })
}
